import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Header, Footer } from "./components/layout";
import ScrollToTop from "./components/common/ScrollToTop";
import ScrollToHash from "./components/common/ScrollToHash";
import AnalyticsTracker from "./components/analytics/AnalyticsTracker";
import Home from "./pages/Home";
import Initiatives from "./pages/Initiatives";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Newsletter from "./pages/Newsletter";
import NewsletterDetail from "./pages/NewsletterDetail";
import Research from "./pages/Research";
import ResearchDetail from "./pages/ResearchDetail";
import InitiativeDetail from "./pages/InitiativeDetail";
import DesignThinking from "./pages/DesignThinking";
import About from "./pages/About";
import TagPage from "./pages/TagPage";
import ProfessorE from "./pages/ProfessorE";
import AiLiteracyTutor from "./pages/AiLiteracyTutor";

function App() {
  return (
    <div className="App layout-container path-frontpage page-node-type-landing-page">
      <Router>
        <ScrollToTop />
        <ScrollToHash />
        <AnalyticsTracker />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/initiatives" element={<Initiatives />} />
          <Route path="/initiatives/:slug" element={<InitiativeDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/newsletter/:slug" element={<NewsletterDetail />} />
          <Route path="/research" element={<Research />} />
          <Route path="/research/:slug" element={<ResearchDetail />} />
          <Route path="/design-thinking" element={<DesignThinking />} />
          <Route path="/professor-e" element={<ProfessorE />} />
          <Route path="/ai-literacy-tutor" element={<AiLiteracyTutor />} />
          <Route path="/tag/:tag" element={<TagPage />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
